<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">{{ route.params.id ? 'Editar Nível de Turma' : 'Novo Nível de Turma' }}</h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarNivel" @cancel="voltar">
        <!-- Dados do Nível de Turma -->
        <FormSection title="Informações do Nível">
          <InputField
            v-model="nivel.nivel"
            label="Nome do Nível <span class='required'>*</span>"
            id="nivel"
            placeholder="Digite o nome do nível"
            required
            :class="{ 'error-input': errors.nivel }"
            width="400px"
          />

          <div class="mb-3">
            <label class="form-label">Cor da Borda</label>
            <div class="d-flex align-items-center gap-2">
              <input type="color" v-model="nivel.cor_borda" class="form-control form-control-color" />
              <input type="text" v-model="nivel.cor_borda" class="form-control" placeholder="#0E2C83" maxlength="7" />
            </div>
            <small v-if="errors.cor_borda" class="error-message">{{ errors.cor_borda }}</small>
            <div class="cert-mini mt-2" :style="miniStyle">
              <span class="mini-label">Pré-visualização</span>
            </div>
          </div>

          <div class="form-group">
            <label for="ativo">Status <span class="required">*</span></label>
            <div class="form-switch">
              <input
                type="checkbox"
                id="ativo"
                v-model="nivel.ativo"
                class="form-check-input"
              />
              <label for="ativo" class="form-check-label">
                {{ nivel.ativo ? "Ativo" : "Inativo" }}
              </label>
            </div>
          </div>
        </FormSection>
      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import InputField from "@/components/Layout/InputField.vue";
  import FormSection from "@/components/Layout/FormSection.vue";
  import BaseForm from "@/components/Layout/BaseForm.vue";
  import axios from "@/services/axios";
  
  export default {
    components: { InputField, FormSection, BaseForm },
    setup() {
      const route = useRoute();
      const router = useRouter();
  
      const nivel = reactive({
        id: null,
        nivel: "",
        ativo: true, // Valor padrão
        cor_borda: "#333333", 
      });
  
      const errors = reactive({});
      const formTouched = ref(false);
      const isSubmitting = ref(false);
  
      const validateForm = () => {
        errors.nivel = nivel.nivel ? "" : "O nome do nível é obrigatório.";
        errors.cor_borda = (/^#[0-9A-Fa-f]{6}$/).test(nivel.cor_borda || '')
          ? "" : "Use o formato #RRGGBB.";
      };
  
      const isFormValid = computed(() => {
        return nivel.nivel.trim() !== '' &&
              !Object.values(errors).some((e) => e);
      });
  
      const novoNivel = () => {
        formTouched.value = false;
        isSubmitting.value = false;
        Object.assign(nivel, {
          nivel: "",
          ativo: true,
        });
        for (const key in errors) {
          if (Object.hasOwn(errors, key)) errors[key] = "";
        }
      };
  
      const salvarNivel = async () => {

        if (isSubmitting.value) return;
  
        validateForm();
  
        if (!isFormValid.value) {
          console.error("O formulário contém erros:", errors);
          return;
        }
  
        isSubmitting.value = true;
        try {
          const method = nivel.id ? "put" : "post";
          const url = nivel.id
            ? `/cadastros/niveis-turmas/${nivel.id}`
            : "/cadastros/niveis-turmas";
  
          await axios[method](url, {
            nivel: nivel.nivel,
            ativo: nivel.ativo, // Inclui o valor do status
            cor_borda: nivel.cor_borda || null,
          });
  
          router.push("/cadastros/niveis-turmas");
        } catch (error) {
          console.error("Erro ao salvar nível:", error);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/cadastros/niveis-turmas");
      };
  
      onMounted(async () => {
        const nivelId = route.params.id;
  
        if (nivelId) {
          try {
            const response = await axios.get(`/cadastros/niveis-turmas/${nivelId}`);
            Object.assign(nivel, response.data);
            if (!nivel.cor_borda) nivel.cor_borda = '#333333';
          } catch (error) {
            console.error("Erro ao carregar nível:", error);
          }
        } else {
          novoNivel();
        }
      });
  
      return {
        nivel,
        errors,
        isFormValid,
        formTouched,
        isSubmitting,
        salvarNivel,
        voltar,
        route,
        miniStyle: computed(() => ({
          boxShadow: `inset 0 0 0 12px ${nivel.cor_borda || '#333333'}`,
          borderRadius: '8px',
          height: '80px',
          background: '#fff'
        })),
      };
    },
  };
  
</script>
  
<style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .error-input {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
  }
  
  .form-switch {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .cert-mini { width: 100%; display:flex; align-items:center; justify-content:center; }
  .mini-label { font-size: .8rem; color: #666; }

</style>
  